import { AnchorProps } from '@/components/base/anchor'
import { ImageProps } from '@/components/base/image'
import { VideoProps } from '@/components/base/video'
import { ReferenceMapping } from '@wap-client/services'

export interface LezzetDuraklariProps {
  video: VideoProps
  title: string
  description: string
}

export interface LezzetDurakgi {
  baslik: string
  sehir: string
  resim: ImageProps
  kisaAciklama: string
  adres: AnchorProps
}

export const LezzetDurakgi_MAPPERS: ReferenceMapping[] = [
  {
    name: 'baslik',
    path: 'baslik',
    type: 'string',
  },
  {
    name: 'kisaAciklama',
    path: 'kisaAciklama',
    type: 'string',
  },
  {
    name: 'resim',
    path: 'resim',
    type: 'image',
  },
  {
    name: 'sehir',
    path: 'sehir',
    type: 'string',
  },
  {
    name: 'adres',
    path: 'adres',
    type: 'string',
  },
]
